// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__20Wm3","log":"ModalInventoryLogs_log__7ZZ9X","date":"ModalInventoryLogs_date__2vo2R","userName":"ModalInventoryLogs_userName__1CJIa"};